import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function requiredWhen(condition: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors => {
    if (!control) {
      return null;
    }

    if (condition && (control.value === undefined || control.value === null || control.value === '' || control.value.length === 0)) {
      return { required: true };
    }

    return null;
  };
}
